import React from "react";
import PropTypes from "prop-types";
import { Top, Footer, InternalMenu } from "../";
import Sponsors from "../Sponsors/Sponsors.jsx";
import Banner from "../Banner/Banner.jsx";

export const Layout = (props) => {
  return (
    <div className="container-fluid">
      <Top />
      <Banner id={props.bannerId} />
      {props.showInternalMenu && <InternalMenu />}
      {props.children}
      <Sponsors />
      <Footer />
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  showInternalMenu: PropTypes.bool,
};

Layout.defaultProps = {
  showInternalMenu: true,
};
